package com.tovtalk.ui

import kotlinx.browser.document
import org.w3c.dom.HTMLVideoElement

/**
 * Hidden video element used to preload the next reel URL on Web.
 * Wired into TovTalkApp via onPreloadNextVideoUrl so the next reel starts instantly.
 */
private var preloadVideoElement: HTMLVideoElement? = null

private fun getOrCreatePreloadVideo(): HTMLVideoElement {
    var el = preloadVideoElement
    if (el == null) {
        el = document.createElement("video") as HTMLVideoElement
        el.setAttribute("preload", "auto")
        el.setAttribute("playsinline", "true")
        el.style.setProperty("display", "none")
        document.body?.appendChild(el)
        preloadVideoElement = el
    }
    return el
}

fun preloadNextVideoUrl(url: String?) {
    val el = getOrCreatePreloadVideo()
    if (url.isNullOrBlank()) {
        el.removeAttribute("src")
        el.load()
    } else {
        if (el.src != url) {
            el.src = url
            el.load()
        }
        if (url.contains("m3u8")) {
            kotlinx.browser.window.fetch(url).catch { _ -> }
        }
    }
}
